import axios from 'axios';

export default axios.create({
  baseURL: 'https://server-dgerz-new.herokuapp.com',
});
